import { useAppSelector } from "../../App/hooks";
import useRequest from "../../Hooks/useRequest";
import { getPortfo } from "../../Requests/stepRequests";
import PortfoTable from "../PortfoTable";

const StepPortfoTable = () => {
  const sahraUserId = useAppSelector(
    (store) => store.step.addOrderFormValues?.userIds
  );

  const getFirstUserId = () => {
    if (!sahraUserId || !sahraUserId.length) return null;
    return sahraUserId[0];
  };

  const stepPortfoRequest = useRequest(
    () => getPortfo(getFirstUserId()),
    (e: any) => {}
  );
  if (!stepPortfoRequest.response) return <></>;
  return (
    <div className="flex flex-col justify-start items-start gap-2">
      <PortfoTable
        tableData={stepPortfoRequest.response.infos}
        username={stepPortfoRequest.response.sahrausername}
      />
    </div>
  );
};

export default StepPortfoTable;
